module.exports = __webpack_public_path__ + "img/abnormal-record.be22a220.svg";